import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Scrolls without showing a scrollbar; pair with visible scroll hints. */
export const HiddenScrollbarArea = styled(Box)({
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
}) as typeof Box;
